.container {
  max-width: 48rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3.2rem;
}

.separator {
  border: 1px solid var(--color-grey-8);
}
